var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "print-list_box", attrs: { id: "nPrintingPageTable" } },
    [
      _c(
        "div",
        {
          staticClass: "yto-box yto-box-pb",
          staticStyle: { padding: "8px 10px" },
        },
        [
          _c(
            "el-form",
            { ref: "ruleForm", attrs: { inline: true, model: _vm.form } },
            [
              _c("div", { staticClass: "y-f y-f-a" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "textarea-style",
                        attrs: {
                          label: "",
                          prop: "mailNoList",
                          "label-width": "0",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 4,
                            resize: "none",
                            placeholder:
                              "请输入单号，最多100个，请用，或者换行隔开",
                          },
                          model: {
                            value: _vm.form.mailNoList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "mailNoList",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.mailNoList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "createTime", label: "下单时间" } },
                      [
                        _c("yto-date-picker", {
                          attrs: {
                            maxRangeVal: 31,
                            customDaysName: `custom_sepecial_${this.curComponent}_customrange`,
                            curShortcutName: _vm.curShortcutName,
                            clearable: false,
                            editable: false,
                            "picker-options": _vm.pickerOptions1,
                            type: "datetimerange",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "default-time": ["00:00:00", "23:59:59"],
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy.MM.dd HH:mm",
                            disabled: !!_vm.form.mailNoList,
                          },
                          model: {
                            value: _vm.form.createTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "createTime", $$v)
                            },
                            expression: "form.createTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "收件人姓名", prop: "receiveName" } },
                      [
                        _c("el-input", {
                          staticClass: "y-w-200",
                          attrs: {
                            placeholder: "请输入收件人姓名",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.receiveName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "receiveName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.receiveName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "收件人电话", prop: "receiveMobile" } },
                      [
                        _c("el-input", {
                          staticClass: "y-w-200",
                          attrs: {
                            placeholder: "请输入收件人电话",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.receiveMobile,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "receiveMobile",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.receiveMobile",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "发件人姓名", prop: "sendName" } },
                      [
                        _c("el-input", {
                          staticClass: "y-w-200",
                          attrs: {
                            placeholder: "请输入发件人姓名",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.sendName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "sendName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.sendName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "发件人电话", prop: "sendMobile" } },
                      [
                        _c("el-input", {
                          staticClass: "y-w-200",
                          attrs: {
                            placeholder: "请输入发件人电话",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.sendMobile,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "sendMobile",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.sendMobile",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品信息", prop: "goodName" } },
                      [
                        _c("el-input", {
                          staticClass: "y-w-200",
                          attrs: {
                            placeholder: "请输入商品信息",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.goodName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "goodName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.goodName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注信息", prop: "remark" } },
                      [
                        _c("el-input", {
                          staticClass: "y-w-200",
                          attrs: {
                            placeholder: "请输入备注信息",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remark,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "remark",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.remark",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.curComponent != "APPLY_ORDER"
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: "订单状态", prop: "waybillStatus" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "y-w-200",
                                attrs: {
                                  "popper-append-to-body": false,
                                  placeholder: "请选择订单状态",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.waybillStatus,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "waybillStatus", $$v)
                                  },
                                  expression: "form.waybillStatus",
                                },
                              },
                              [
                                _vm._l(_vm.waybillStatusList, function (item) {
                                  return [
                                    !item.disable
                                      ? _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.name,
                                            value: item.code,
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                                _vm.curComponent == "ALL_ORDER"
                                  ? _c("el-option", {
                                      attrs: { label: "已取消", value: "30" },
                                    })
                                  : _vm._e(),
                                _vm.curComponent == "ALL_ORDER"
                                  ? _c("el-option", {
                                      attrs: { label: "取件失败", value: "20" },
                                    })
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { icon: "el-icon-search", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.pageChange(1)
                              },
                            },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "border-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.resetForm("ruleForm")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-refresh-left y-fc-4C84FF",
                            }),
                            _vm._v("重置 "),
                          ]
                        ),
                        _vm.curComponent == "ALL_ORDER"
                          ? _c(
                              "el-button",
                              {
                                staticClass: "border-btn",
                                attrs: {
                                  icon: "el-icon-download",
                                  type: "button",
                                  disabled: _vm.exportOrderListFlag,
                                },
                                on: { click: _vm.exportOrderList },
                              },
                              [_vm._v("导出")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "yto-table yto-ks-box ksNewOrderTable",
          staticStyle: { padding: "8px 10px" },
        },
        [
          _c(
            "div",
            { staticClass: "y-mb-8" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.cancelFn } },
                [_vm._v("取消订单")]
              ),
              _vm.curComponent == "APPLY_ORDER"
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.mergeFn } },
                    [_vm._v("合并订单")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "infinite-list-wrapper newCustomPrintTable",
              staticStyle: { overflow: "auto", "margin-bottom": "60px" },
            },
            [
              _vm.tableHeight
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      ref: "customOrderTable",
                      attrs: { data: _vm.tbody, height: _vm.tableHeight },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "55",
                          selectable: _vm.selectableFn,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "下单时间",
                          "min-width": 80,
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pickupOrderNo",
                          label: "订单号",
                          "min-width": 90,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.pickupOrderNo)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          134339658
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderStatus",
                          label: "订单状态",
                          "min-width": 80,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    scope.row.workStatus
                                      ? _c("span", [_vm._v("订单状态:")])
                                      : _vm._e(),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.getStrFn(
                                            scope.row.waybillStatus,
                                            _vm.waybillStatusList
                                          )
                                        ),
                                      },
                                    }),
                                  ]),
                                  scope.row.workStatus
                                    ? _c("div", [
                                        _c("span", [_vm._v("拦截状态:")]),
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.getStrFn(
                                                scope.row.workStatus,
                                                _vm.lanjieStatusList
                                              )
                                            ),
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  scope.row.payStatus
                                    ? _c("div", [
                                        _vm._v(_vm._s(scope.row.payStatus)),
                                      ])
                                    : _vm._e(),
                                  scope.row.isReturnAmount == "1"
                                    ? _c("div", [_vm._v("运费已退还")])
                                    : _vm._e(),
                                  (scope.row.waybillStatus == "30" ||
                                    scope.row.waybillStatus == "-10") &&
                                  scope.row.failMsg
                                    ? _c("div", [
                                        _vm._v(_vm._s(scope.row.failMsg)),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1118146716
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pickupCode",
                          label: "取件码",
                          "min-width": "70",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "settlementTime",
                          label: "预约取件时间",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(scope.row.settlementTimeYear)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v(_vm._s(scope.row.settlementTime)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          990707579
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sendName",
                          label: "发件人信息",
                          "min-width": "180",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "address-info-style" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.viewSenderAddress
                                                ? scope.row.decryptSendName
                                                : scope.row.sendName
                                            )
                                          ),
                                        ]),
                                        scope.row.viewSenderAddress
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-view y-ml-10 y-c-p",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.decryptAddressInfo(
                                                    scope.row,
                                                    scope.$index,
                                                    "sender"
                                                  )
                                                },
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "view-img-style",
                                              attrs: {
                                                src: require("@/assets/images/view-no.png"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.decryptAddressInfo(
                                                    scope.row,
                                                    scope.$index,
                                                    "sender"
                                                  )
                                                },
                                              },
                                            }),
                                      ]
                                    ),
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.viewSenderAddress
                                              ? scope.row.decryptSendMobile
                                              : scope.row.sendMobile
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "y-ml-10": !!scope.row.sendMobile,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.viewSenderAddress
                                                ? scope.row.decryptSendPhone
                                                : scope.row.sendPhone
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(scope.row.sendProvince || "") +
                                          _vm._s(scope.row.sendCity || "") +
                                          _vm._s(scope.row.sendCounty || "") +
                                          _vm._s(
                                            scope.row.viewSenderAddress
                                              ? scope.row.decryptSendAddress
                                              : scope.row.sendAddress
                                          )
                                      ),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3268665441
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "receiveName",
                          label: "收件人信息",
                          "min-width": "180",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticClass: "address-info-style" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.viewReciverAddress
                                                ? scope.row.decryptReceiveName
                                                : scope.row.receiveName
                                            )
                                          ),
                                        ]),
                                        scope.row.viewReciverAddress
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-view y-ml-10 y-c-p",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.decryptAddressInfo(
                                                    scope.row,
                                                    scope.$index,
                                                    "reciver"
                                                  )
                                                },
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "view-img-style",
                                              attrs: {
                                                src: require("@/assets/images/view-no.png"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.decryptAddressInfo(
                                                    scope.row,
                                                    scope.$index,
                                                    "reciver"
                                                  )
                                                },
                                              },
                                            }),
                                      ]
                                    ),
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.viewReciverAddress
                                              ? scope.row.decryptReceiveMobile
                                              : scope.row.receiveMobile
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "y-ml-10":
                                              !!scope.row.receiveMobile,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.viewReciverAddress
                                                ? scope.row.decryptReceivePhone
                                                : scope.row.receivePhone
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.receiveProvince || ""
                                        ) +
                                          _vm._s(scope.row.receiveCity || "") +
                                          _vm._s(
                                            scope.row.receiveCounty || ""
                                          ) +
                                          _vm._s(
                                            scope.row.viewReciverAddress
                                              ? scope.row.decryptReceiveAddress
                                              : scope.row.receiveAddress
                                          )
                                      ),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4158750102
                        ),
                      }),
                      _vm.curComponent != "APPLY_ORDER"
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "waybillNo",
                              label: "运单号",
                              "min-width": "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "y-f y-f-a" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "linkColor border-box-span",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "systemColor y-c-p",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    $event.stopPropagation()
                                                    return _vm.viewLogisticsTrack(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.waybillNo)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        scope.row.waybillNo
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-document-copy",
                                              attrs: { title: "复制" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  $event.stopPropagation()
                                                  return _vm.copyWaybillNo(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              26763794
                            ),
                          })
                        : _vm._e(),
                      _vm.curComponent != "APPLY_ORDER"
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "printNum",
                              label: "打印状态",
                              "min-width": "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.printNum >= 1
                                              ? "已打印"
                                              : "未打印"
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              502471417
                            ),
                          })
                        : _vm._e(),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goodLists",
                          label: "商品信息",
                          "min-width": "180",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return _vm._l(
                                  scope.row.goodLists || [],
                                  function (good, gidx) {
                                    return _c(
                                      "div",
                                      { key: good.id + "_" + gidx },
                                      [
                                        good.goodName
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "light",
                                                  content:
                                                    good.goodName +
                                                    (good.goodSpecs
                                                      ? "*" + good.goodSpecs
                                                      : "") +
                                                    "*" +
                                                    good.goodNum,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "y-f-multi-ell",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(good.goodName) +
                                                        " " +
                                                        _vm._s(
                                                          good.goodSpecs
                                                            ? "* " +
                                                                good.goodSpecs
                                                            : ""
                                                        ) +
                                                        " * " +
                                                        _vm._s(good.goodNum)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          3054283705
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "remark",
                          label: "备注信息",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.remark
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "light",
                                            content: scope.row.remark,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "y-f-multi-ell" },
                                            [_vm._v(_vm._s(scope.row.remark))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4013164413
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "200", fixed: "right" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      scope.row.waybillStatus == "0"
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "systemColor y-c-p",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.modifyFn(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("修改")]
                                            ),
                                            _c("el-divider", {
                                              attrs: { direction: "vertical" },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "systemColor y-c-p",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.cancelFn(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("取消")]
                                            ),
                                            _c("el-divider", {
                                              attrs: { direction: "vertical" },
                                            }),
                                          ]
                                        : _vm._e(),
                                      (scope.row.waybillStatus == "10" ||
                                        scope.row.waybillStatus == "50") &&
                                      scope.row.payStatus
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "systemColor y-c-p",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.cancelFn(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("取消")]
                                            ),
                                            _c("el-divider", {
                                              attrs: { direction: "vertical" },
                                            }),
                                          ]
                                        : _vm._e(),
                                      scope.row.waybillStatus != "-20" &&
                                      scope.row.waybillStatus != "-10"
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "systemColor y-c-p",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyOrderFn(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("再寄一单")]
                                            ),
                                            _c("el-divider", {
                                              attrs: { direction: "vertical" },
                                            }),
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "systemColor y-c-p",
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewDetailFn(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("详情")]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2199104004
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "paginton-footer-box box-shadow-wrapper",
              class: { "collapse-footer": !_vm.isCollapse },
            },
            [
              _vm.isRefreshTemplate
                ? _c("changeTemplate", {
                    ref: "tempRef",
                    attrs: {
                      platformCode: "SPECIALORDER",
                      curComponent: _vm.curComponent,
                      templateAList: _vm.templateList,
                      curTemplateId: _vm.selectPrinterForm.tempId,
                    },
                    on: {
                      changeTemplateId: _vm.changeTemplateId,
                      addOneTemplate: function ($event) {
                        _vm.isShowAddTemplateDialog = true
                      },
                      deleteTemplate: _vm.deleteTemplate,
                    },
                  })
                : _vm._e(),
              _c("div", { staticClass: "split-line" }),
              _c(
                "div",
                { staticClass: "totalFooter-top y-f-a" },
                [
                  _c("div", { staticClass: "y-fs-14" }, [
                    _vm._v(" 已选 "),
                    _c(
                      "span",
                      {
                        staticClass: "totalNumStyle",
                        staticStyle: { color: "red" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.selectData ? _vm.selectData.length : 0)
                        ),
                      ]
                    ),
                    _vm._v(" 条记录（共 "),
                    _c(
                      "span",
                      {
                        staticClass: "totalNumStyle",
                        staticStyle: { color: "#000" },
                      },
                      [_vm._v(_vm._s(_vm.total))]
                    ),
                    _vm._v("条） "),
                  ]),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.curComponent == "PRINTED_ORDER",
                          expression: "curComponent == 'PRINTED_ORDER'",
                        },
                      ],
                      staticClass: "print-footer-medium",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh-right",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              _vm.selectPrinterForm.isOnlyApply = false
                              _vm.batchPrinting(true)
                            },
                          },
                        },
                        [_vm._v(" 原单重打 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.curComponent == "APPLY_ORDER" ||
                            _vm.curComponent == "ALL_ORDER",
                          expression:
                            "curComponent == 'APPLY_ORDER' || curComponent == 'ALL_ORDER'",
                        },
                      ],
                      staticClass: "print-footer-medium",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.selectPrinterForm.isOnlyApply = false
                              _vm.batchPrinting(false)
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "icon-svg-style",
                            attrs: { "icon-class": "dayin-printer" },
                          }),
                          _vm._v("打印快递单 "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageNo,
                      "page-sizes": [100, 300, 500, 1000],
                      "page-size": _vm.limit,
                      "pager-count": 5,
                      layout: "sizes, prev, pager, next",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.limitChange,
                      "current-change": _vm.pageChange,
                      "update:currentPage": function ($event) {
                        _vm.pageNo = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.pageNo = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.logisticsTrackDialog
        ? _c("order-tracking-details", {
            ref: "orderTrackingDetails",
            attrs: {
              value: _vm.logisticsTrackDialog,
              data: _vm.logisticsTrack,
              noWorkOrderAndRecive: true,
            },
            on: { close: _vm.closeLogisticsTrackDialog },
          })
        : _vm._e(),
      _vm.detailDialog
        ? _c("orderDetail", {
            attrs: { isShow: _vm.detailDialog, rowInfo: _vm.currentRow },
            on: { closeDialog: _vm.closeDetialDialog },
          })
        : _vm._e(),
      _vm.modifyDialog
        ? _c("modifyDialog", {
            ref: "modifyDialog",
            attrs: { isShow: _vm.modifyDialog, rowInfo: _vm.currentRow },
            on: { closeDialog: _vm.closeModifyDialog },
          })
        : _vm._e(),
      _vm.isShowValidateDialog
        ? _c("validatePrintItems", {
            attrs: {
              isShow: _vm.isShowValidateDialog,
              senderList: [],
              curSenderId: _vm.selectPrinterForm.sernderId,
              templateAList: _vm.templateList,
              curTemplateId: _vm.selectPrinterForm.tempId,
              step: _vm.validateStep,
              platformType: "CUSTOM",
            },
            on: {
              closeValiDialog: _vm.closeValiDialog,
              refreshOriginList: _vm.refreshOriginList,
              addOneTemplate: _vm.addOneTemplate,
            },
          })
        : _vm._e(),
      _vm.isShowAddTemplateDialog
        ? _c("addTemplateDialog", {
            attrs: {
              visible: _vm.isShowAddTemplateDialog,
              tplList: _vm.templateList,
              defaultCpCode: _vm.defaultCpCode,
              defaultPlatformType: _vm.defaultPlatformType,
              closeByConfirm: _vm.getTemplateList,
            },
            on: {
              "update:visible": function ($event) {
                _vm.isShowAddTemplateDialog = $event
              },
              showShopSetting: _vm.showShopSettingFromFaceTpl,
            },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "customSelectWaybillPrinter",
          attrs: {
            title: _vm.selectPrinterForm.isOnlyApply
              ? "仅获取单号"
              : "打印快递单",
            width: "710px",
            "custom-class": "ninvoiceDialog",
            id: "dialogForScan",
            visible: _vm.selectPrinterDialogVisible,
            "close-on-click-modal": false,
            "before-close": _vm.closeSelectPrinterForm,
          },
          on: {
            "update:visible": function ($event) {
              _vm.selectPrinterDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "resetSelectPrinterForm",
              attrs: {
                model: _vm.selectPrinterForm,
                "label-width": "190px",
                rules: _vm.selectPrinterFormRules,
              },
            },
            [
              _c("printWarningTip", {
                attrs: {
                  alertTitle: _vm.alertTitle,
                  selectPrinterForm: _vm.selectPrinterForm,
                },
              }),
              _c(
                "el-form-item",
                { attrs: { label: "您本次选择的打印模板是：", prop: "" } },
                [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.curTemplateInfo.tempName))]),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "快递单打印机", prop: "printer" } },
                [
                  _c(
                    "span",
                    { staticClass: "custom-select-style" },
                    [
                      _c("span", {
                        staticClass: "systemColor",
                        domProps: {
                          textContent: _vm._s(_vm.getDefautPrinter()),
                        },
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "custom-select-border-style",
                          class: {
                            "custom-select-style-input-default-printer":
                              _vm.getDefautPrinter() == "默认",
                            "custom-select-style-input-pinter":
                              _vm.getDefautPrinter() !== "默认",
                          },
                          attrs: {
                            "popper-append-to-body": false,
                            placeholder: "请选择快递单打印机",
                          },
                          model: {
                            value: _vm.selectPrinterForm.printer,
                            callback: function ($$v) {
                              _vm.$set(_vm.selectPrinterForm, "printer", $$v)
                            },
                            expression: "selectPrinterForm.printer",
                          },
                        },
                        _vm._l(_vm.printerList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.printerList.length
                    ? _c(
                        "span",
                        {
                          staticClass: "systemColor",
                          staticStyle: {
                            "font-size": "12px",
                            "margin-left": "5px",
                            cursor: "pointer",
                          },
                          on: { click: _vm.setDefaultPrinter },
                        },
                        [_vm._v("设置默认打印机")]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer align-center-box",
              staticStyle: { "margin-bottom": "10px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeSelectPrinterForm } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitPrintForm },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.selectPrinterForm.isOnlyApply ? "仅获取单号" : "打 印"
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("order-print", {
        ref: "orderPrintComponent",
        on: { "close-print-dialog": _vm.closePrinting },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }